module.exports = __webpack_public_path__ + "static/media/img.c14ce24a.jpg";